import { ref, onMounted, nextTick } from "vue";

export default function showElOnMounted() {
  const showEl = ref(false);

  const enableShowEl = () => (showEl.value = true);

  onMounted(() => nextTick(() => nextTick(enableShowEl)));
  return showEl;
}
